import { useState } from "react";
import { faqList } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

export default function FaqBlock() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-6 lg:px-8">
        <SectionHeading
          eyebrow="常见问题"
          title="吃瓜前，先看这里"
          desc="关于蹲后续、催更、指路和内容来源的疑问，这里都有答案。"
        />

        <div className="mt-10 flex flex-col gap-3">
          {faqList.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen ? "border-primary-200 bg-primary-50/40" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-bold text-secondary-800">
                      Q
                    </span>
                    {f.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                      isOpen ? "bg-primary-500 text-background-50 rotate-180" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200/70 px-5 py-4">
                    <p className="flex gap-3 text-sm leading-7 text-foreground-700">
                      <span className="shrink-0 font-heading text-sm font-bold text-accent-500">A</span>
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}